module.exports = __webpack_public_path__ + "../resources/images/illustration_archive-e3897db27b0c4bcede15d555cc95a659.svg";